jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchstart", handle, { passive: false });
    } else {
      this.addEventListener("touchstart", handle, { passive: true });
    }
  },
};

jQuery.event.special.touchmove = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchmove", handle, { passive: false });
    } else {
      this.addEventListener("touchmove", handle, { passive: true });
    }
  },
};

(function () {
  "use strict";
  window.addEventListener(
    "load",
    function () {
      var forms = document.getElementsByClassName("needs-validation");
      var validation = Array.prototype.filter.call(forms, function (form) {
        form.addEventListener(
          "submit",
          function (event) {
            console.log("form submitted.");
            if (form.checkValidity() === false) {
              event.preventDefault();
              event.stopPropagation();
              $(form).addClass("has-errors");
            } else {
              $(form).removeClass("has-errors");
              $(form).addClass("submitting");
            }
            form.classList.add("was-validated");
          },
          false
        );
      });
    },
    false
  );
})();

/**** SEARCH ****/
var $body = $("body");
var $searchOpen = $(".search-open");
var $searchClose = $(".close-side.close-search");
var $searchContainer = $(".side-container.search-container");

/**** NAVI ****/
var $naviOpen = $(".hamburger-open");
var $naviClose = $(".close-side.close-navi");
var $naviContainer = $(".side-container.navi-container");
var $body = $("body");

$naviOpen.on("click", function () {
  if ($naviContainer.css("display") === "none") {
    $naviContainer
      .css({ visibility: "visible", display: "block" })
      .animate({ opacity: 1 }, 300);
    $body.addClass("side-open");
    $(".accessibility-toggle .icon").addClass("navi-open");
  }
});

$naviClose.on("click", function () {
  if ($naviContainer.css("display") === "block") {
    $naviContainer.animate({ opacity: 0 }, 300, function () {
      $naviContainer.css({ visibility: "hidden", display: "none" });
      $body.removeClass("side-open");
      $(".accessibility-toggle .icon").removeClass("navi-open");
    });
  }
});

$searchOpen.on("click", function () {
  if ($searchContainer.css("display") === "none") {
    $searchContainer
      .css({ visibility: "visible", display: "block" })
      .animate({ opacity: 1 }, 300);
    $body.addClass("side-open");
    $(".accessibility-toggle .icon").addClass("navi-open");
  }
});

$searchClose.on("click", function () {
  if ($searchContainer.css("display") === "block") {
    $searchContainer.animate({ opacity: 0 }, 300, function () {
      $searchContainer.css({ visibility: "hidden", display: "none" });
    });
    $body.removeClass("side-open");
    $(".accessibility-toggle .icon").removeClass("navi-open");
  }
});

//POPUP
$("#popup").on("click", function () {
  Cookies.set("popUp", "ok");
});

if (Cookies.get("popUp") === "ok") {
  $("#popup").modal("hide");
} else {
  setTimeout(function () {
    $("#popup").modal("show");
  }, 3000);
}

$(".cookie-consent-open-settings").on("click", function () {
  $("#cookie-consent").css("display", "flex");
});

// SIVKA
$(".kranjskaSivka").on("click", function () {
  $(this).hide();
  $(".faq").show();
});

$(".kranjskaSivka").on("keypress", function (event) {
  // Check if the key pressed is Enter (key code 13)
  if (event.which === 13) {
    $(this).hide();
    $(".faq").show();
    $(".faq_form input#faqName").focus();
  }
});

$(".faq_form .icon-close").on("click", function (e) {
  $(".faq").hide();
  $(".kranjskaSivka").show();
});

$(".faq_form form").on("submit", function (e) {
  e.preventDefault();

  var form = $(this);
  var url = form.attr("action");

  grecaptcha.ready(function () {
    grecaptcha
      .execute(form.data("sitekey"), { action: "submit" })
      .then(function (token) {
        if ($("input.website").val().length != 0) {
          return false;
        }
        $(".faq_form form .error").hide();

        $.ajax({
          type: "POST",
          url: url,
          data: form.serialize() + "&recaptcha_token=" + token,
          success: function (data) {
            if (data == "success") {
              $(".faq_form").hide();
              $(".faq_thankyou").show();
            } else {
              $(".faq_form form .error").show();
            }
          },
        });
      });
  });
});

var articlesLoader = {
  init: function (targetSelector, articleType, view) {
    $(targetSelector).find(".list-loader").show();

    var params = {
      article_type: articleType,
      view: view
    };
    if ($(targetSelector).data('pageid')) {
      params.page_id = $(targetSelector).data('pageid');
    }

    $.post(
      "/article/get-by-type",
      params,
      function (html) {
        $(targetSelector).html(html);

        if (targetSelector == '.funerals-container-dynamic') {
          if ($(".funerals-container .funerals-slider").length > 0) {
            new Splide(".funerals-container .funerals-slider", {
              pagination: false,
              arrows: true,
              drag: true,
              autoplay: false,
              speed: 2000,
              perPage: 4,
              breakpoints: {
                1024: {
                  perPage: 3,
                },
                720: {
                  perPage: 2,
                },
                425: {
                  perPage: 1,
                },
              },
            }).mount();
          }
        } else if (targetSelector == '.notifications-container-dynamic') {
          if ($(".notifications .notifications-slider").length > 0) {
            new Splide(".notifications .notifications-slider", {
              pagination: false,
              arrows: true,
              drag: true,
              autoplay: false,
              speed: 2000,
              perPage: 1,
            }
            ).mount();
          }
        } else if (targetSelector == '.home-notifications-container-dynamic') {
          if ($(".home-notifications-slider").length > 0) {
            new Splide(".home-notifications-slider", {
              pagination: false,
              arrows: true,
              drag: true,
              autoplay: true,
              interval: 4000,
              speed: 4000,
              perPage: 1,
              type: 'slide'
            }).mount();
          }
        }
      }
    );
  }
};